import { render, staticRenderFns } from "./rZhuyuan.vue?vue&type=template&id=1f481d92&scoped=true&"
import script from "./rZhuyuan.vue?vue&type=script&lang=js&"
export * from "./rZhuyuan.vue?vue&type=script&lang=js&"
import style0 from "./rZhuyuan.vue?vue&type=style&index=0&id=1f481d92&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f481d92",
  null
  
)

export default component.exports